import { Directive, Input } from '@angular/core';
import { FontLoaderService } from '../services';

@Directive({
    selector: '[htmlContentFontLoader]',
    standalone: false
})
export class HtmlContentFontLoaderDirective {

  @Input() public set htmlContentFontLoader(content: string) {
    this.loadFonts(content);
  }

  constructor(
    private readonly fontLoaderService: FontLoaderService) { }

  private loadFonts(content: string): void {
    this.fontLoaderService.loadHtmlContentFonts(content);
  }
}